export const meetingSelector = state => state.meeting.get('meeting');
export const meetingIsLoadingSelector = state => state.meeting.get('isLoading');
